// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
// import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions"; // Store Custom Code
// import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage"; // Store Custom Code
// import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation"; // Store Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
// import ProductListProductImage, {
//     ProductListProductImageStyles,
// } from "@insite/content-library/Widgets/ProductList/ProductListProductImage"; // Store Custom Code
import { productCardProps } from "@store/Themes/common/props/productCard";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import Hidden from "@insite/mobius/Hidden";
import ContentZone from "@store/Library/Components/ContentZone";
import ProductListActions from "@store/Overrides/Widgets/ProductList/ProductListActions";
import ProductListProductImage, {
    ProductListProductImageStyles,
} from "@store/Overrides/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation from "@store/Overrides/Widgets/ProductList/ProductListProductInformation";

export interface OwnProps {
    isModalContext?: boolean;
}

type Props = OwnProps & ProductCardSelections & HasProduct;
/* Store Custom Code - End */

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    // Starter Custom Code
    productListProductImage?: ProductListProductImageStyles;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: productCardProps.card,
    imageWrapper: productCardProps.image?.wrapper,
    sponsoredText: mergeProps<ProductListProductGridCardStyles["sponsoredText"]>(productCardProps.sponsoredText, {
        css: css`
            border-left: 0;
        `,
    }),
    productListProductImage: {
        compareCheckbox: {
            mergeCss: true,
            css: css`
                margin-bottom: ${pxToRem(-4)};
            `,
        },
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    // Store Custom Code
    isModalContext = false,
}) => {
    /* Store Custom Code - Start */

    if (!product) {
        return null;
    }

    const [keyFeatures, setKeyFeatures] = React.useState("");

    React.useEffect(() => {
        if (product.properties.keyFeatures) {
            setKeyFeatures(product.properties.keyFeatures);
        }
    }, [product]);

    /* Store Custom Code - End */

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            {showImage /* Starter Custom Code */ ? (
                <StyledWrapper {...styles.imageWrapper}>
                    {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                    <ProductListProductImage
                        showImage={showImage}
                        showCompare={showCompare}
                        showImageBadge={showImageBadges}
                        showTextBadge={showTextBadges}
                        extendedStyles={styles.productListProductImage}
                        // Store Custom Code
                        productListView="Grid"
                    />
                </StyledWrapper>
            ) : null}
            <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
                // Store Custom Code
                showPrice={showPrice}
            />
            {/* Store Custom Code - Start */}
            <ProductListActions isModalContext={isModalContext} showAddToList={showAddToList} showPrice={false} />
            {/* Store Custom Code - End */}
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductGridCard);
